import { useQuery } from "@tanstack/react-query"
import { getNetworks } from "../api"

export function useNetworks() {
  return useQuery({
    queryKey: ["networks"],
    queryFn: () => getNetworks(),
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
